export { default } from 'features/menu/routes/menu-route';
